// Display only a city explicitly present in the saved, comma-separated location.
// Keep the complete source string for the tooltip and Maps query.
const countryNames = new Map();
const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
for (let a = 65; a <= 90; a++) for (let b = 65; b <= 90; b++) {
  const code = String.fromCharCode(a, b);
  const name = regionNames.of(code);
  if (name && name !== code && !['EU', 'UN', 'ZZ', 'XA', 'XB'].includes(code)) countryNames.set(name.toLowerCase(), { code, name });
}
for (const name of ['us', 'usa', 'u.s.', 'united states of america']) countryNames.set(name, { code: 'US', name: 'US' });
for (const name of ['uk', 'u.k.', 'great britain', 'united kingdom']) countryNames.set(name, { code: 'GB', name: 'UK' });

function contextualCity(city, full) {
  if (!city || city === 'City omitted') return city;
  const parts = full.split(',').map(p => p.trim()).filter(Boolean);
  const last = parts[parts.length - 1] || '';
  let country = countryNames.get(last.toLowerCase());
  // A two-part city/state string such as Mountain View, CA is ambiguous.
  if (!country && parts.length >= 3 && /^[A-Z]{2}$/i.test(last)) {
    const code = last.toUpperCase(), name = regionNames.of(code);
    if (name && name !== code && !['EU', 'UN', 'ZZ', 'XA', 'XB'].includes(code)) country = { code, name };
  }
  if (!country || country.code === 'CA') return city;
  const cityIndex = /^\d/.test(parts[0]) ? 1 : 0;
  const region = parts.slice(cityIndex + 1, -1).join(', ');
  const countryText = country.code === 'US' ? 'US' : country.code === 'GB' ? 'UK' : country.name;
  return `${city} — ${[region, countryText].filter(Boolean).join(', ')}`;
}

export function locationLabel(location, review, sourceUrl) {
  const full = String(location || '').trim();
  if (!full) return { city: '', display: '', full: '', mapsUrl: '' };
  const parts = full.split(',').map(part => part.trim()).filter(Boolean);
  const streetFirst = /^\d/.test(parts[0]);
  const candidate = streetFirst ? parts[1] : parts[0];
  const city = candidate && !/^(?:remote\b|worldwide\b|global\b|canada$|united states$|usa$|us$|unknown$|not stated$)/i.test(candidate)
    ? candidate : 'City omitted';
  if (review) {
    const current = review.saved_location === full && (!sourceUrl || review.posting_source_url === sourceUrl);
    const verified = current && review.status === 'verified_address' && review.full_address && review.map_url;
    const safeMap = verified && /^https:\/\/(?:www\.)?google\.(?:com|ca)\/maps(?:\/|\?)/.test(review.map_url);
    return {
      city: current ? review.city || city : city,
      display: contextualCity(current ? review.city || city : city, full),
      full: safeMap ? [review.full_address, review.note].filter(Boolean).join('\n')
        : `${full}\nFull workplace address ${review.status === 'conflicting_address' ? 'conflicts across sources' : 'not verified'}. ${current ? review.reason || '' : 'Location or posting changed; review required.'}`,
      mapsUrl: safeMap ? review.map_url : '',
    };
  }
  return {
    city,
    display: contextualCity(city, full),
    full,
    mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(full)}`,
  };
}
